import { SerializedStyles, useTheme } from "@emotion/react"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import React from "react"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { InfoBox } from "../InfoBox"

type Props = {
  title: string
  subtitle?: string
  icon?: IconDefinition
  additionalStyling?: SerializedStyles
}

export const ErrorBox = ({
  title,
  subtitle,
  icon = solid("warning"),
  additionalStyling,
}: Props) => {
  const theme = useTheme()
  return (
    <InfoBox
      icon={icon}
      additionalStyling={additionalStyling}
      title={title}
      subTitle={subtitle}
      backgroundColor={theme.colors.errorLight}
      color={theme.colors.errorDark}
    />
  )
}
